//accordion
function setHeightBody(el) {
    el.each(function SH(index, item) {
        if($(item).hasClass('open')) {
            let elHeight = $(item).prop('scrollHeight');
            $(item).css('height', elHeight);
        } else {
            $(item).removeAttr('style');
        }
    });
}

$(document).ready(function() {
    const accordion = $('.js-accordion-item');
    setHeightBody(accordion.find('.js-accordion-body'));

    accordion.on('click', function H() {
        $(this).toggleClass('open');
        $(this).find('.js-accordion-body').toggleClass('open');
        setHeightBody(accordion.find('.js-accordion-body'));
    });
});
